import { Outlet } from 'react-router'

export const AuthPage = () => {

    return <Outlet />
}
